(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kin-designers"]) return;
  try {
    
(()=>{
  const initialise=async root=>{
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    const grid=root.querySelector('.kd-grid');
    const pagination=root.querySelector('.kd-pagination');
    let next=pagination?.dataset.next;
    const seen=new Set();
    try{
      while(next){
        const url=new URL(next,location.href);
        for(const key of ['view','preview_theme_id'])if(!url.searchParams.has(key)&&new URL(location.href).searchParams.has(key))url.searchParams.set(key,new URL(location.href).searchParams.get(key));
        if(url.origin!==location.origin||seen.has(url.href))throw new Error('Invalid pagination');
        seen.add(url.href);
        const response=await fetch(url,{signal:AbortSignal.timeout(12000)});
        if(!response.ok)throw new Error('Could not load designers');
        const documentPart=new DOMParser().parseFromString(await response.text(),'text/html');
        const nextGrid=documentPart.querySelector('#kin-designers .kd-grid');
        if(!nextGrid)throw new Error('Missing designer grid');
        Array.from(nextGrid.children).forEach(card=>grid.appendChild(document.importNode(card,true)));
        next=documentPart.querySelector('#kin-designers .kd-pagination')?.dataset.next;
      }
    }catch(error){return;}
    if(pagination)pagination.hidden=true;
    const cards=Array.from(grid.children).sort((a,b)=>Number(a.dataset.rank)-Number(b.dataset.rank)||Number(b.dataset.products)-Number(a.dataset.products)||a.dataset.name.localeCompare(b.dataset.name,'en',{sensitivity:'base'}));
    const input=root.querySelector('#kd-search');
    const sort=root.querySelector('#kd-sort');
    const reset=root.querySelector('.kd-reset');
    const more=root.querySelector('.kd-more');
    const status=root.querySelector('.kd-results');
    const empty=root.querySelector('.kd-empty');
    const messages=JSON.parse(document.getElementById('kd-messages').textContent);
    let limit=24;
    const normal=value=>value.toLocaleLowerCase('en-GB').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
    function render(){
      const query=normal(input.value);
      const terms=query.split(/\s+/).filter(Boolean);
      const ordered=sort.value==='az'?cards.slice().sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name,'en',{sensitivity:'base'})):cards;
      const matches=ordered.filter(card=>terms.every(term=>normal(card.dataset.designer).includes(term)));
      const shown=new Set(matches.slice(0,limit));
      ordered.forEach(card=>{card.hidden=!shown.has(card);grid.appendChild(card);});
      const message=messages[(query?'search_':'results_')+(matches.length===1?'one':'many')];
      status.textContent=matches.length===0?messages.empty_status:message.replace('__SHOWN__',String(Math.min(limit,matches.length))).replace('__TOTAL__',String(matches.length));
      reset.hidden=!query;more.hidden=matches.length<=limit;empty.hidden=matches.length>0;
    }
    input.addEventListener('input',()=>{limit=24;render();});
    sort.addEventListener('change',()=>{limit=24;render();});
    reset.addEventListener('click',()=>{input.value='';limit=24;render();input.focus();});
    more.querySelector('button').addEventListener('click',()=>{const oldLimit=limit;limit+=24;render();Array.from(grid.children).filter(card=>!card.hidden)[oldLimit]?.querySelector('a').focus({preventScroll:true});});
    root.querySelector('.kd-tools').hidden=false;
    render();
  };
  const start=()=>initialise(document.getElementById('kin-designers'));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kin-priority-collection-help"]) return;
  try {
    
if (!customElements.get('kin-priority-collection-help')) {
  customElements.define('kin-priority-collection-help', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      document.addEventListener('facet:update', (event) => this.refresh(event), { signal: this.lifecycle.signal });
    }
    disconnectedCallback() {
      this.lifecycle.abort();
      this.request?.abort();
    }
    async refresh(event) {
      if (!event.detail?.url) return;
      const url = new URL(event.detail.url, location.origin);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      this.request?.abort();
      const request = this.request = new AbortController();
      this.hidden = true;
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = parsed.getElementById(this.id);
        if (!replacement || request.signal.aborted || !this.isConnected) return;
        this.replaceChildren(...document.importNode(replacement, true).childNodes);
        this.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
